import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { FiAlertTriangle, FiTrash2, FiX } from 'react-icons/fi';

const s = {
    overlay: {
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0,0,0,0.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2100,
        padding: '16px',
    },
    card: {
        background: '#fff',
        borderRadius: '16px',
        width: '100%',
        maxWidth: '400px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
        overflow: 'hidden',
    },
    iconRow: {
        display: 'flex',
        justifyContent: 'center',
        paddingTop: '32px',
        paddingBottom: '4px',
    },
    iconCircle: {
        width: '56px',
        height: '56px',
        borderRadius: '50%',
        backgroundColor: '#fff1f2',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    body: {
        padding: '12px 28px 24px',
        textAlign: 'center',
    },
    title: {
        fontSize: '15px',
        fontWeight: '600',
        color: '#111827',
        margin: '12px 0 6px',
        lineHeight: 1.4,
    },
    description: {
        fontSize: '13px',
        color: '#6b7280',
        margin: 0,
        lineHeight: 1.5,
    },
    divider: {
        borderTop: '1px solid #f3f4f6',
        margin: '0',
    },
    footer: {
        display: 'flex',
        gap: '10px',
        padding: '16px 24px',
        background: '#fff',
    },
    btnCancel: {
        flex: 1,
        padding: '9px 0',
        fontSize: '13px',
        fontWeight: '600',
        color: '#374151',
        backgroundColor: '#f3f4f6',
        border: '1.5px solid #e5e7eb',
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'background-color 0.15s ease',
    },
    btnConfirm: {
        flex: 1,
        padding: '9px 0',
        fontSize: '13px',
        fontWeight: '600',
        color: '#fff',
        backgroundColor: '#dc2626',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'background-color 0.15s ease',
        boxShadow: '0 2px 6px rgba(220,38,38,0.3)',
    },
};

const DeletePopup = ({
    open = true,
    title,
    description,
    onConfirm,
    onCancel,
    confirmLabel = "Yes, I'm sure",
    cancelLabel = 'No',
}) => {
    if (!open) return null;

    return ReactDOM.createPortal(
        <div style={s.overlay} onClick={(e) => { if (e.target === e.currentTarget) onCancel(); }}>
            <div style={s.card} onClick={(e) => e.stopPropagation()}>

                {/* Icon */}
                <div style={s.iconRow}>
                    <div style={s.iconCircle}>
                        <FiTrash2 size={24} color="#dc2626" />
                    </div>
                </div>

                {/* Body */}
                <div style={s.body}>
                    <p style={s.title}>{title}</p>
                    {description && <p style={s.description}>{description}</p>}
                </div>

                {/* Divider */}
                <div style={s.divider} />

                {/* Footer */}
                <div style={s.footer}>
                    <button
                        type="button"
                        style={s.btnCancel}
                        onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#e5e7eb'; }}
                        onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#f3f4f6'; }}
                        onClick={onCancel}
                    >
                        {cancelLabel}
                    </button>
                    <button
                        type="button"
                        style={s.btnConfirm}
                        onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#b91c1c'; }}
                        onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#dc2626'; }}
                        onClick={onConfirm}
                    >
                        {confirmLabel}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};

DeletePopup.propTypes = {
    open: PropTypes.bool,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    confirmLabel: PropTypes.string,
    cancelLabel: PropTypes.string,
};

export default DeletePopup;
